import { createContext } from 'react';
const ACCORDION_GROUP_CONTEXT_DEFAULT_VALUE = [
    {
        allowCollapse: false,
        isGrouped: false,
        expandedId: null,
    },
    () => null,
];
export const AccordionGroupContext = createContext(ACCORDION_GROUP_CONTEXT_DEFAULT_VALUE);
